"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ListItemBoxText = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireWildcard(require("../../Typography"));
var _Intl = _interopRequireDefault(require("../../proptypes/Intl"));
var _classnames = _interopRequireDefault(require("./classnames"));
var _ListItemBoxText = require("./ListItemBoxText.utils");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var styles = {
  "listItemBoxTextWrapper": "M7wqJB",
  "interactionSecondaryDefault": "UUv0SI"
};
var ListItemBoxText = exports.ListItemBoxText = function ListItemBoxText(_ref) {
  var text = _ref.text,
    secondaryText = _ref.secondaryText,
    textDataTestId = _ref.textDataTestId,
    level = _ref.level,
    hasLeftContent = _ref.hasLeftContent,
    hasRightContent = _ref.hasRightContent,
    disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_classnames["default"].LIST_ITEM_BOX_TEXT_WRAPPER, styles.listItemBoxTextWrapper),
    style: {
      '--actions-count': (0, _ListItemBoxText.getActionsCount)(hasLeftContent, hasRightContent)
    }
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    as: "span",
    level: level,
    kind: disabled ? _Typography.Kind.DISABLED : _Typography.Kind.DEFAULT,
    className: (0, _clsx["default"])(_classnames["default"].LIST_ITEM_BOX_TEXT_TEXT, styles.listItemBoxTextTypography, !disabled && styles.interactionSecondaryDefault),
    "data-testid": textDataTestId
  }, (0, _ListItemBoxText.getByFormatText)(text)), secondaryText && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    as: "span",
    level: "caption",
    kind: disabled ? _Typography.Kind.DISABLED : _Typography.Kind.DEFAULT,
    className: (0, _clsx["default"])(_classnames["default"].LIST_ITEM_BOX_TEXT_SECONDARY_TEXT, styles.listItemBoxTextTypography)
  }, (0, _ListItemBoxText.getByFormatText)(secondaryText)));
};
ListItemBoxText.propTypes = process.env.NODE_ENV !== "production" ? {
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _Intl["default"]]),
  secondaryText: _propTypes["default"].oneOfType([_propTypes["default"].string, _Intl["default"]]),
  textDataTestId: _propTypes["default"].string,
  level: _propTypes["default"].string,
  hasLeftContent: _propTypes["default"].bool,
  hasRightContent: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
} : {};
var _default = exports["default"] = ListItemBoxText;